export const nextPackageDetails = (theme) => ({
    root: {
        width: "100%",
        background: "#aaa",
        marginTop: "20px",
    },
    bold: {
        fontWeight: "bold",
    },
    divider: {
        borderRight: "2px solid black",
        height: "100%",
    },
    flex: {
        display: "flex",
    },
});
